// Allows to create a relative path from absolute one for react router
export const relativePath = (path: string, parentPath: string) => {
  return path.substring(
    parentPath.endsWith('/') ? parentPath.length : parentPath.length + 1
  )
}
